const _TemplatesGroupedByTheme =
{
	/* EDIT THEME - Interactive mode for browsers */
	Edit: [
		{
			HashPostfix: '-Template-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML*/`
			<!-- InputType PhoneNumber (using 'PhoneNumberProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control control-status has-icons-left">
						<span class="control-status-icon"></span>
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="tel"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~Required:Record~}
							{~Disabled:Record~}
							placeholder="{~Placeholder:Record~}"
							{~D:Record.Macro.InputFullProperties~}
							{~D:Record.Macro.InputChangeHandler~}
							autoComplete="on"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-phone fa-xs"></i>
						</span>
					</p>
					<p class="help"><span class="description-text">{~D:Record.Description~}</span></p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML*/`
			<!-- InputType PhoneNumber (using 'PhoneNumberProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control control-status has-icons-left">
								<span class="control-status-icon"></span>
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="tel"
									class="input"
									{~D:Record.Macro.ControlAttr~}
									{~Required:Record~}
									{~Disabled:Record~}
									placeholder="{~Placeholder:Record~}"
									{~D:Record.Macro.InputFullProperties~}
									{~D:Record.Macro.InputChangeHandler~}
									autoComplete="on"
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-phone fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType PhoneNumber (using PhoneNumberProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="field mb-0">
				<p class="control control-status has-icons-left">
					<span class="control-status-icon"></span>
					<input
						id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
						type="tel"
						class="input"
						{~D:Record.Macro.ControlAttr~}
						{~Required:Record~}
						{~Disabled:Record~}
						placeholder="{~Placeholder:Record~}"
						{~D:Record.Macro.HTMLName~}
						{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PhoneNumber',
			Template: /*HTML-Partial*/`
						value=""
					/>
					<span class="icon is-small is-left">
						<i class="fas fa-phone fa-xs"></i>
					</span>
				</p>
			</div>
			<p class="help"></p>`,
		},
	],
	/* READ THEME - Interactive mode for browsers in a locked/disabled/readonly state */
	Read: [
		{
			HashPostfix: '-Template-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML*/`
			<!-- InputType PhoneNumber (using PhoneNumberProvider) {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<p class="control has-icons-left">
						<input
							id="{~D:Record.Macro.RawHTMLID~}"
							type="tel"
							class="input"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							readonly aria-readonly="true"
							value=""
						/>
						<span class="icon is-small is-left">
							<i class="fas fa-phone fa-xs"></i>
						</span>
					</p>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML*/`
			<!-- InputType PhoneNumber (using 'PhoneNumberProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-3">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div class="field">
							<p class="control has-icons-left">
								<input
									id="{~D:Record.Macro.RawHTMLID~}"
									type="tel"
									class="input"
									readonly aria-readonly="true"
									{~D:Record.Macro.ControlAttr~}
									{~D:Record.Macro.InputFullProperties~}
									value=""
								/>
								<span class="icon is-small is-left">
									<i class="fas fa-phone fa-xs"></i>
								</span>
							</p>
						</div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType PhoneNumber (using PhoneNumberProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<p class="control has-icons-left">
				<input
					id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
					type="tel"
					class="input"
					{~D:Record.Macro.ControlAttr~}
					{~D:Record.Macro.HTMLName~}
					{~D:Record.Macro.InformaryTabular~}
					readonly aria-readonly="true" `,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PhoneNumber',
			Template: /*HTML-Partial*/`
					value=""
				/>
				<span class="icon is-small is-left">
					<i class="fas fa-phone fa-xs"></i>
				</span>
			</p>`,
		},
	],
	/* PRINT THEME - Non-interactive mode for PDF documents */
	Print: [
		{
			HashPostfix: '-Template-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML*/`
			<!-- DataType PhoneNumber {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="column {~ColumnWidth:Record~} {~HideInPDF:Record~}">
				<div class="field">
					<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					<div class="control">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-VerticalTemplate-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML*/`
			<!-- InputType PhoneNumber (using 'PhoneNumberProvider') {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div class="pict-form-vertical-input column pb-1 {~HideInPDF:Record~}">
				<div class="columns is-mobile is-vcentered">
					<div class="column">
						<label {~D:Record.Macro.HTMLForID~} class="label {~HideLabel:Record~}">{~LabelWithChips:Record~}</label>
					</div>
					<div class="column description-text">{~D:Record.Description~}</div>
					<div class="column">
						<div
							id="{~D:Record.Macro.RawHTMLID~}"
							class="input is-static"
							{~D:Record.Macro.ControlAttr~}
							{~D:Record.Macro.InputFullProperties~}
							value=""
						></div>
					</div>
				</div>
			</div>`,
		},
		{
			HashPostfix: '-TabularTemplate-Begin-Input-InputType-PhoneNumber',
			DefaultInputExtensions: [ 'PhoneNumberProvider' ],
			Template: /*HTML-Partial*/`
			<!-- InputType PhoneNumber (using PhoneNumberProvider)  {~D:Record.Hash~} {~D:Record.DataType~} -->
			<div
				id="{~D:Record.Macro.RawHTMLID~}-{~D:Context[2].Key~}"
				class="input is-static"
				{~D:Record.Macro.ControlAttr~}
				{~D:Record.Macro.HTMLName~}
				{~D:Record.Macro.InformaryTabular~}`,
		},
		{
			HashPostfix: '-TabularTemplate-End-Input-InputType-PhoneNumber',
			Template: /*HTML-Partial*/`
			></div>`,
		},
	],
};

module.exports = _TemplatesGroupedByTheme;
